import React from 'react'
import './Navbar.css'
import logoLong from '../../images/logo-long.png'
import { Link } from "react-router-dom";
import { useState } from 'react';
import { useMediaQuery } from '../../hooks/useMediaQuery';

const Navbar = () => {
  const [openNav, setOpenNav] = useState(false)
  const isMobileNav = useMediaQuery('(max-width: 1100px)')
  const drawerInert = isMobileNav && !openNav

  return (
    <header className="site-header">
      <div id="main__navbar__wrapper">
        <nav id="main__navbar" aria-label="Primary navigation">
          <Link
            to="/"
            className='navbar__logo-link'
            onClick={() => setOpenNav(false)}
            aria-label="The Functional Nurse Practitioner — Home"
          >
            <img src={logoLong} alt="" className='navbar__logo' width={1048} height={238} />
          </Link>
          <div
            id="primary-navigation"
            className={openNav ? 'navbar__drawer active' : 'navbar__drawer'}
            inert={drawerInert ? true : undefined}
          >
            <ul className='navbar__links'>
              <li><Link to="/" onClick={() => setOpenNav(false)}>Home</Link></li>
              <li><Link to="/about" onClick={() => setOpenNav(false)}>About</Link></li>
              <li><Link to="/what-is-functional-medicine" onClick={() => setOpenNav(false)}>Our Approach</Link></li>
              <li><Link to="/membership" onClick={() => setOpenNav(false)}>Membership</Link></li>
              <li><Link to="/podcast" onClick={() => setOpenNav(false)}>Podcast</Link></li>
            </ul>
            <ul className='navbar__buttons'>
              <li>
                <a
                  href="https://www.optimantra.com/optimus/om/patient/login"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Secure Client Portal
                </a>
              </li>
              <li>
                <a
                  href='https://www.optimantra.com/optimus/patient/patientaccess/servicesall?mid=1023&pid=NWxtalFOa1M1ZDZwSTNwZ3AzY08vdz09&lid=TmNIZ3FKUFdhVm1YME1lQkMxUEE5QT09&hideFooterInFrame=&hideHeaderInFrame='
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Book a free consultation
                </a>
              </li>
            </ul>
          </div>
          <button
            type="button"
            aria-expanded={openNav}
            aria-controls="primary-navigation"
            aria-label={openNav ? 'Close menu' : 'Open menu'}
            className={openNav ? 'navbar__hide__open active' : 'navbar__hide__open'}
            onClick={() => setOpenNav(!openNav)}
          >
            <span className='bar1' aria-hidden="true" />
            <span className='bar2' aria-hidden="true" />
            <span className='bar3' aria-hidden="true" />
          </button>
        </nav>
      </div>
    </header>
  )
}

export default Navbar
